import { CircularProgress } from '@mui/material'
import type { CircularProgressProps } from '@mui/material'

type LoadingSpinnerOMIconProps = {
  size?: string | number
  /** 'primary' (brand) is the default; 'secondary' reads as `fg.subtle` for a more muted spinner. */
  color?: CircularProgressProps['color']
}

/**
 * Nucleo has no animated spinner, so this centralises the themed `CircularProgress` instead —
 * use it anywhere a loading state sits in an icon slot (e.g. an icon mapping's `loading` variant),
 * rather than reaching for `CircularProgress` directly each time.
 */
export const LoadingSpinnerOMIcon = ({ size, color }: LoadingSpinnerOMIconProps) => <CircularProgress size={size} color={color} />
